import { render, staticRenderFns } from "./BarrierButton.vue?vue&type=template&id=185b3887"
import script from "./BarrierButton.vue?vue&type=script&lang=ts"
export * from "./BarrierButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports